var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#50BEE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23248 30C6.90248 30 6.54248 29.8187 6.54248 29.38V23.7037C6.54248 23.3437 6.90248 23.0837 7.23248 23.0837H9.52123C14.0887 23.0837 13.9875 30 9.60998 30H7.23248ZM7.86248 24.3025V28.78H9.52123C12.22 28.78 12.3387 24.3025 9.52123 24.3025H7.86248Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 30.1C15.9637 30.18 14.0437 28.95 14.0437 26.5012C14.0437 24.0425 15.9625 22.8337 17.8125 22.8337C19.5612 22.9225 21.39 24.1325 21.39 26.5012C21.39 28.8712 19.5612 30.1 17.8125 30.1ZM17.7025 24.1337C16.5825 24.1337 15.3637 24.9237 15.3637 26.5025C15.3637 28.0725 16.5837 28.8725 17.7025 28.8725C18.8525 28.8725 20.0812 28.0725 20.0812 26.5025C20.0812 24.9225 18.8525 24.1337 17.7025 24.1337Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5663 26.4912C22.5663 24.5625 23.7763 22.9037 26.075 22.9037C26.945 22.9037 27.635 23.1637 28.3638 23.7937C28.6338 24.0425 28.6638 24.4825 28.3938 24.7625C28.1238 25.0012 27.7138 24.9725 27.4738 24.7325C27.065 24.3025 26.645 24.1837 26.075 24.1837C24.5363 24.1837 23.7975 25.2737 23.7975 26.4925C23.7975 27.7325 24.5263 28.8712 26.075 28.8712C26.645 28.8712 27.175 28.64 27.635 28.2312C27.9438 27.9912 28.3738 28.11 28.5538 28.3512C28.7138 28.5712 28.7925 28.9412 28.4438 29.29C27.7438 29.9412 26.905 30.0712 26.0738 30.0712C23.6563 30.0712 22.5663 28.42 22.5663 26.4912Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.44368f4d.svg";
export { ForwardRef as ReactComponent };